export default "/images/24a2df5d5471eb8321b318aecc733f46.avif";